/* globals showModalInfo */
import React, { useEffect, useContext, useState } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import MarkdownHelpModal from "common/MarkdownHelpModal";
import help from "help/viewClusterConfiguration.md";
import BqnList from "./BqnList";
import { ClusterStatus } from "../ClusterStatus";
import { Header } from "common/Header";
import BqnContext from "common/BqnContext";
import BqnIdModal from "./BqnIdModal";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);

  const { loadClusterStatus } = useContext(BqnContext);

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help")}
      >
        <i className="material-icons">help_outline</i>
      </a>
      <a
        onClick={() => {
          loadClusterStatus();
          actions.send("do-load");
        }}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">refresh</i>
      </a>
    </ul>
  );
};

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const ActionsLayout = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const ClusterConfiguration = ({ returnView }) => {
  const [showBqnIdModal, setShowBqnIdModal] = useState(false);
  const actions = useContext(ActionsContext);
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext);

  useEffect(() => () => actions.clear(), []);

  function syncSshKeys() {
    ifCl
      .run("system users ssh sync")
      .then((response) =>
        showModalInfo("SSH keys synchronized correctly", response)
      );
  }

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <Header
          title="Cluster Configuration"
          backButton={returnView}
          contextMenu={<ContextMenu />}
        ></Header>
        <div className="body flex-panel-column panel-group">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <ClusterStatus />
            </div>
          </div>
          <ActionsLayout>
          {mode === "standalone" && (
              <button
                type="button"
                className="btn btn-default waves-effect shadow-none hidden-to-operators"
                onClick={() => setShowBqnIdModal(true)}
              >
                <i className="material-icons">label_outline</i>
                <span>Modify BQN ID</span>
              </button>
            )}
            <button
              type="button"
              className="btn btn-default waves-effect shadow-none hidden-to-operators"
              onClick={() => actions.send("add-bqn")}
            >
              <i className="material-icons">device_hub</i>
              <span>
                {mode === "standalone"
                  ? "Add BQN to a cluster..."
                  : "Add BQN to this cluster..."}
              </span>
            </button>
            {mode === "cluster" && (
              <button
                type="button"
                className="btn btn-default waves-effect shadow-none hidden-to-operators"
                onClick={() => syncSshKeys()}
              >
                <i className="material-icons">swap_vert</i>
                <span>Sync SSH keys</span>
              </button>
            )}
          </ActionsLayout>
          <BqnList />
        </div>
        <MarkdownHelpModal title="Cluster Configuration" source={help} />
        {showBqnIdModal && (
          <BqnIdModal onClose={() => setShowBqnIdModal(false)} />
        )}
      </div>
    </div>
  );
};

export default ClusterConfiguration;
